import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { NumberByLocale } from '../../../../../components/Element';
import { translateProductNameCallback } from '../../../../../helpers/i18n';

const CandidateCorrectionRadioField = ({ field, form, correction, testType, isSingle, ...props }) => {
  const { i18n, t } = useTranslation();
  const translateProductName = translateProductNameCallback(i18n, t);

  const logisticCode = correction ? correction.logisticCode.toLowerCase() : 'standard';
  const id = correction ? correction.id : 'none';

  return (
    <Fragment>
      {isSingle ? (
        <div className="candidate-options__correction candidate-options__correction--single">
          <div className="candidate-options__correction-description candidate-options__correction-description--single">
            {testType && <Trans>{testType.get('translationKey')}.single-standard.description.b2c</Trans>}
          </div>
        </div>
      ) : (
        <div className="candidate-options__correction">
          <input
            id={logisticCode}
            type="radio"
            name={field.name}
            value={id}
            className="candidate-options__correction-input"
            checked={id === field.value}
            onChange={field.onChange}
            {...props}
          />
          <label htmlFor={logisticCode} className="candidate-options__correction-label-block">
            <div className="candidate-options__correction-label">
              {correction && correction.price ? (
                translateProductName(correction.translationKey)
              ) : (
                <Trans>session-registration.products-and-services.correction.label.{logisticCode}</Trans>
              )}
            </div>
            <div className="candidate-options__correction-description">
              {correction && <Trans>{correction.translationKey}.description.b2c</Trans>}
              {testType && <Trans>{testType.get('translationKey')}.standard.description.b2c</Trans>}
            </div>
            <span className="candidate-options__correction-price">
              {correction && correction.price ? (
                <NumberByLocale currency={correction.price.currency} value={correction.price.value} />
              ) : (
                <Trans>session-registration.products-and-services.correction.price.{logisticCode}</Trans>
              )}
            </span>
          </label>
        </div>
      )}
    </Fragment>
  );
};

CandidateCorrectionRadioField.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  isSingle: PropTypes.bool,
  correction: PropTypes.shape({
    id: PropTypes.string,
    translationKey: PropTypes.string,
    price: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.string,
    }),
    logisticCode: PropTypes.string,
  }),
  testType: PropTypes.shape({
    translationKey: PropTypes.string,
  }),
};

export default CandidateCorrectionRadioField;
